export const DEFAULT_USER_DETAILS = {
  name: "",
  gabit: "",
  healthGoal: "",
};

export const assessmentQuestionsAndGabitMap = {
  fullName: "FITNESS",
  age: "FITNESS",
  gender: "FITNESS",
  height: "FITNESS",
  weight: "FITNESS",
  barriers: "FITNESS",
  how_you_feel: "FITNESS",
  fitness_paid_congrats: "FITNESS",
  Live_Additional_Workout: "FITNESS",
  Recorded_Additional_Workout: "FITNESS",
  With_Without_Weights: "FITNESS",
  preferredTimeSlot: "FITNESS",
  Level: "FITNESS",
  skin_type: "FITNESS",
  skin_concern: "FITNESS",
  Muscle_Stiffness: "FITNESS",
  previous_workouts: "FITNESS",
  preferredTimeSlotForYAH: "FITNESS",
  preferredTimeSlotForDiabetes: "FITNESS",
  "we-get-you": "FITNESS",
  "support-you": "FITNESS",
  gamified_fitness: "FITNESS",
  // Time_Slot: "FITNESS",
  // Training_Weekdays: "FITNESS",
  // Health_Goal: "FITNESS",
};
